import { create } from 'zustand';

export interface ConfirmOptions {
  title: string;
  body: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}

interface ConfirmState {
  open: boolean;
  opts: ConfirmOptions | null;
  resolver: ((ok: boolean) => void) | null;
  show: (opts: ConfirmOptions) => Promise<boolean>;
  resolve: (ok: boolean) => void;
}

export const useConfirm = create<ConfirmState>((set, get) => ({
  open: false,
  opts: null,
  resolver: null,
  show: (opts) =>
    new Promise<boolean>((resolve) => {
      set({ open: true, opts, resolver: resolve });
    }),
  resolve: (ok) => {
    const r = get().resolver;
    set({ open: false, opts: null, resolver: null });
    if (r) r(ok);
  },
}));

/** Удобная функция: `if (await confirmAction({title:'...', body:'...'})) {...}` */
export function confirmAction(opts: ConfirmOptions): Promise<boolean> {
  return useConfirm.getState().show(opts);
}
